import { useQuery } from "@tanstack/react-query";
import { getTrendingTalents, getTrendingProfessionals } from "../../services/users";
import { useTranslation } from "react-i18next";

export const useTrendingTalents = () => {
  const { i18n } = useTranslation();

  const { data, isLoading } = useQuery({
    queryKey: ["trendingTalents", i18n.language],
    queryFn: async () => await getTrendingTalents(),
  });

  return { trendingTalents: data, isTrendingTalentsLoading: isLoading };
};

export const useTrendingProfessionals = () => {
  const { i18n } = useTranslation();

  const { data, isLoading } = useQuery({
    queryKey: ["trendingProfessionals", i18n.language],
    queryFn: async () => await getTrendingProfessionals(),
  });

  return { trendingProfessionals: data, isTrendingProfessionalsLoading: isLoading };
};
